import { Link } from '@calendly/ui/components/link';
import classNames from 'classnames';
import { forwardRef } from 'react';
import BillingClickCapture from 'components/billing/click_capture';
const styledLinkCss = "s1yzmpui";
const StyledLink = forwardRef((props, ref) => <Link ref={ref} {...props} className={classNames(styledLinkCss, props.className)} />);
export const UpgradeLink = ({
  children,
  featureKey,
  onClick = () => {}
}) => <BillingClickCapture featureName={featureKey} onClick={onClick}>
    <StyledLink as="button">
      {children}
    </StyledLink>
  </BillingClickCapture>;

require("./shared.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./shared.js");